import { fetchFactory } from 'isotope-client'


export const getConversionList = () => fetchFactory('/conversion')
